$(function() {
  // Hotfix for screen-size based widgets in backend
  $('body.neos-backend').on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function() {
    $(window).trigger('resize');
  });

  // Hotfix for rendering issues on node removal
  if($('body.neos-backend').length) {
    document.addEventListener('Neos.NodeRemoved',function(event) {
      Typo3Neos.Content.reloadPage();
    });
  }

  // Hotfix for empty href attributes in link tags
  $('a').each(function() {
    if($(this)[0].hasAttribute('href') && !$(this).attr('href')) {
      $(this).removeAttr('href');
    }
  });
});
